// SES caption rows (the "Caption" a journal entry rolls up to, e.g. "Employee stock options issued").
// Mirrors the role of cfsIndirectTemplateJson/cfsDirectTemplateJson for CFS, but SES has no
// Indirect/Direct method split, so this is a single flat list instead of a nested head->children tree.
export const sesTemplateJson = [
    { id: "ses-1", title: "Equity issued", isGroupable: true },
    { id: "ses-2", title: "Employee stock options issued", isGroupable: true },
    { id: "ses-3", title: "Dividend", isGroupable: true },
    { id: "ses-4", title: "Debt converted into equity", isGroupable: true },
    { id: "ses-5", title: "Equity converted into debt", isGroupable: true },
    { id: "ses-6", title: "Prior period expenses", isGroupable: true },
    { id: "ses-7", title: "Prior period income", isGroupable: true },
];

// SES statement columns (equity components). "Number of shares" is intentionally excluded —
// it is a manual, non-dollar input (see SES spec 1.06), not something a journal entry maps to.
export const sesColumnsJson = [
    { id: "col-1", title: "Common stock" },
    { id: "col-2", title: "Additional paid-in capital" },
    { id: "col-3", title: "Retained earnings" },
];
